import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const lockContributorShotClass = (classId) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.LOCK_CONTRIBUTOR_SHOTCLASS(
      classId
    )
  );
};

export default lockContributorShotClass;
